import React from 'react'
import ReactDOM from 'react-dom/client'

import TournamentForm from "championship/src/components/TournamentForm";


function init( config ){
    const dom_root = config.root
    const root = ReactDOM
        .createRoot(dom_root)

    // const data = JSON.parse(document.getElementById('tournament_form_app_form').textContent)
    // const data_settings = JSON.parse(document.getElementById('tournament_form_app_form_settings').textContent)

    const init_data = {
        // tournament: JSON.parse(document.getElementById('tournament_form_app_form').textContent),
        // settings: JSON.parse(document.getElementById('tournament_form_app_form_settings').textContent),
        // participants: JSON.parse(document.getElementById('tournament_form_app_form_participants').textContent),
        // requests: JSON.parse(document.getElementById('tournament_form_app_form_requests').textContent),
    }

    const csrf_token = document.getElementsByName('csrfmiddlewaretoken')[0].value

    const get_url = dom_root.getAttribute('data-league-get')
    const post_url = dom_root.getAttribute('data-league-post')
    const tournament_id = dom_root.getAttribute('data-tournament-id')

    const api_routes = {
        get: get_url,
        post: post_url,
    }

    root.render(
        <TournamentForm
            init_data={init_data}
            csrf_token={csrf_token}
            api_routes={api_routes}
            // league_slug={league_slug}
            // get_url={get_url}
            // post_url={post_url}
            tournament_id={tournament_id}
            />
    );
}

export {
    init
}